// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-matrix-container {
    background: var(--sa-card);
    border-radius: 14px;
    overflow: hidden;
}

.sa-matrix-header {
    display: grid;
    padding: 14px 18px;
    border-bottom: 1px solid var(--sa-border);
    background: var(--sa-surface);
}

.sa-matrix-cat-row {
    padding: 7px 18px;
    background: var(--sa-bg);
    font-size: 9px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    gap: 5px;
}

.sa-matrix-row {
    display: grid;
    padding: 9px 18px;
    border-bottom: 1px solid var(--sa-border);
    align-items: center;
    transition: background 0.1s;
}

.sa-matrix-row:hover {
    background: var(--sa-card-hover);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/SuperAdmin/SAPermMatrix.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,yCAAyC;IACzC,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;AACpC","sourcesContent":[".sa-matrix-container {\n    background: var(--sa-card);\n    border-radius: 14px;\n    overflow: hidden;\n}\n\n.sa-matrix-header {\n    display: grid;\n    padding: 14px 18px;\n    border-bottom: 1px solid var(--sa-border);\n    background: var(--sa-surface);\n}\n\n.sa-matrix-cat-row {\n    padding: 7px 18px;\n    background: var(--sa-bg);\n    font-size: 9px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.sa-matrix-row {\n    display: grid;\n    padding: 9px 18px;\n    border-bottom: 1px solid var(--sa-border);\n    align-items: center;\n    transition: background 0.1s;\n}\n\n.sa-matrix-row:hover {\n    background: var(--sa-card-hover);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
